import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, Input, Output, forwardRef, inject } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileRepositoryService } from '@common/service/file-repository.service';
import { DataUtils, FileLoadError } from '@core/utils/data-util.service';
import { HasAnyAccessDirective } from '@shared/directives/has-any-access.directive';
import TmwTranslatePipe from '@shared/pipes/translate.pipe';
// import {AttachedDocumentService} from 'src/app/modules/demande/request/blocks/attached-file/service/attached-document.service';
import TmwAbbreviate from '../../../pipes/abbreviate.pipe';

const noop = () => {
  return;
};

const FILEUPLOAD_CONTROL_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TmwFileUploadComponent),
};

@Component({
  selector: 'tmw-file-upload',
  standalone: true,
  providers: [FILEUPLOAD_CONTROL_VALUE_ACCESSOR],
  imports: [CommonModule, FormsModule, TmwTranslatePipe, HasAnyAccessDirective, TmwAbbreviate],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class TmwFileUploadComponent {
  private readonly destroy: DestroyRef = inject(DestroyRef);
  fileRepositoryService = inject(FileRepositoryService);
  _model: any;
  @Input() set model(m: any) {
    console.dir(m);
    this._model = m ?? {};
    this.initData();
  }
  get model() {
    return this._model;
  }

  @Output() deleted = new EventEmitter();
  @Output() idChange = new EventEmitter();
  @Output() fileChange = new EventEmitter();
  @Output() downloadFile = new EventEmitter();
  fileId: number | undefined;
  file: any;
  fileContentType: any;
  fileName: any = '';
  _fieldName!: string;

  @Input({ required: true }) set fieldName(fn: string) {
    this._fieldName = fn;
    this.initData();
  }

  get fieldName(): string {
    return this._fieldName;
  }
  @Input() isImage: boolean = false;
  @Input() isExcel: boolean = false;
  @Input() ext: string | undefined;

  disableInput = false;
  init = false;
  @Input() set id(_id: number) {
    //TODO get from server
  }

  @Input() useBase64?: boolean = true;

  @Input('readOnly') readOnlyInput?: boolean = false;

  private onTouch: () => void = noop;
  private onChange: (_: any) => void = noop;

  constructor(
    protected dataUtils: DataUtils
    // private service: AttachedDocumentService,
  ) {}

  ngOnInit() {
    if (!this.init) {
      this.initData();
    }
    // this.service.fileChange$.subscribe(() => {
    //   this.fileName = '';
    // });
  }

  initData() {
    if (this.fieldName && this.model && JSON.stringify(this.model.fileRepositoryId) !== '{}') {
      this.init = true;
      if (!isNaN(this.model?.[`${this.fieldName}Id`])) {
        this.fileId = this.model?.[`${this.fieldName}Id`];
      }
      this.file = this.model?.[`${this.fieldName}File`];
      if (this.model[this.fieldName + 'Name']?.length) {
        this.fileName = this.model[this.fieldName + 'Name'] ?? '';
      }
    }
  }

  openFile(): void {
    // if (this.file && !this.file?.bucketName) {
    //   this.dataUtils.openFile(this.file, this._model.fileRepositoryMimeType);
    // } else if (this.fileId) {
    this.downloadFile.emit();
    // this.fileRepositoryService.getFile(this.fileId).subscribe({
    //   next: (result) => {
    //     if (result) {
    //       this.file = result.fileRepositoryFile;
    //       this.fileContentType = result.fileRepositoryMimeType;
    //       this.dataUtils.openFile(result.fileRepositoryFile, result.fileRepositoryMimeType);
    //     }
    //   },
    // });
    // }
  }

  setFileData(event: Event): void {
    this.dataUtils.loadFileToForm(event, this.model, this.fieldName, this.isImage, this.isExcel, this.useBase64).subscribe({
      next: () => {
        this.fileName = this.model[this.fieldName + 'Name'] ?? '';
        this.file = this.model[this.fieldName + 'File'];
        this.fileChange.emit(this.model);
        this.onTouch();
        this.onChange(this.model[this.fieldName + 'File']);
      },
      error: (err: FileLoadError) => {
        //TODO alert error
        console.error(err);
      },
    });
  }

  deleteFile() {
    let id = this.model[this.fieldName + 'Id'];
    this.onChange(undefined);
    this.onTouch();
    this.file = this.model[this.fieldName + 'File'] = undefined;
    this.fileId = this.model[this.fieldName + 'Id'] = undefined;
    this.fileName = this.model[this.fieldName + 'Name'] = '';
    this.fileContentType = this.model[this.fieldName + 'ContentType'] = undefined;
    this.deleted.emit(id);
  }

  public writeValue(value: any) {
    this.file = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disableInput = isDisabled;
  }
}
